const trendingData = [
  {
    id: "0123456789",
    imgSrc:
      "https://media.sketchfab.com/models/86fd6cec31e347289571a039852c02ed/thumbnails/d5826ebcceac4a36a2e2c1382506ab39/5da9b4d3987f4c7396a4ffe179a149bf.jpeg",
    type: "pic",
    favorite: 123,
    collectionName: "Eternal Glory",
    collectionBadges: ["Verified"],
    currency: "Gems",
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
    creator: {
      name: "Gosho",
      avatar:
        "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
      royalties: 10,
    },
    details: {
      name: "Zombie CaptainAmerica #1",
      dropDate: "09 Oct 2021",
      listPrice: 90,
      editionSupply: 10,
      edition: 3,
      editionType: "Con Exclusive",
      season: "2",
      rarity: "Secret",
      license: "Marvel",
      brand: "Captain America",
      collection: "Zombie",
      series: "Zombie CaptainAmerica",
      annotations: ["rare", "wearable", "armor"],
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit commodi deleniti itaque adipisci sunt ducimus aperiam optio iste odit similique esse minima sed, tempore quo sapiente incidunt magnam alias nisi doloribus quae earum obcaecati ratione? Beatae, tempora voluptas adipisci in, suscipit praesentium explicabo odio quaerat, dolorem eaque tempore. Porro, saepe."
    },
    bids: [
      {
        id: 1,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "1/12/2021 13:38:55",
        value: "10.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "2/12/2021 13:37:00",
        value: "20",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "3/12/2021 13:35:00",
        value: "30.9",
        currency: "BUSD",
      },
      {
        id: 4,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "4/12/2021 13:33:23",
        value: "40.9",
        currency: "BUSD",
      },
      {
        id: 5,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "5/12/2021 13:30:23",
        value: "50.99",
        currency: "BUSD",
      },
    ],
    ownersData: [
      {
        id: 1,
        user: {
          name: "Pesho 1",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "20/06/22 24:33",
        value: "2.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "gosho 2",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "21/06/22 24:33",
        value: "15.6",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "Stef 3",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "22/06/22 24:33",
        value: "10.6",
        currency: "BUSD",
      },
    ],
    historyData: [
      {
        id: 1,
        event: "Mint",
        price: 1234567890123456789,
        currency: "ETH",
        from: "B323234965412365412541294311289541625131628541269",
        to: "Crypto-Kitties-Auction",
        date: "21/12/2020",
      },
      {
        id: 2,
        event: "Transfer",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "22/12/2020",
      },
      {
        id: 3,
        event: "List",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "31/12/2020",
      },
      {
        id: 3,
        event: "Sale",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction1876d46asdsa",
        date: "01/01/2021",
      },
      {
        id: 3,
        event: "Bid",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "15/01/2021",
      },
    ],
    more: [
      { id: 1 },
      { id: 3 },
      { id: 4 },
      { id: 5 },
      { id: 6 },
      { id: 7 },
      { id: 8 },
      { id: 9 },
    ],
  },
  {
    id: 1,
    imgSrc:
      "https://img.rarible.com/prod/image/upload/t_gif_preview/prod-itemImages/0xd07dc4262bcdbf85190c01c996b4c06a461d2430:735733/b8c56884",
    type: "gif",
    favorite: 1234,
    collectionName: "Defence mercenaries",
    collectionBadges: ["Verified"],
    currency: "Gems",
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
    creator: {
      name: "Gosho",
      avatar:
        "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
      royalties: 10,
    },
    details: {
      name: "Zombie CaptainAmerica #1",
      dropDate: "09 Oct 2021",
      listPrice: 90,
      editionSupply: 10,
      edition: 3,
      editionType: "Con Exclusive",
      season: "2",
      rarity: "Secret",
      license: "Marvel",
      brand: "Captain America",
      collection: "Zombie",
      series: "Zombie CaptainAmerica",
      annotations: ["rare", "wearable", "armor"],
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit commodi deleniti itaque adipisci sunt ducimus aperiam optio iste odit similique esse minima sed, tempore quo sapiente incidunt magnam alias nisi doloribus quae earum obcaecati ratione? Beatae, tempora voluptas adipisci in, suscipit praesentium explicabo odio quaerat, dolorem eaque tempore. Porro, saepe."
    },
    bids: [
      {
        id: 1,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "1/12/2021 13:38:55",
        value: "10.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "2/12/2021 13:37:00",
        value: "20",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "3/12/2021 13:35:00",
        value: "30.9",
        currency: "BUSD",
      },
      {
        id: 4,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "4/12/2021 13:33:23",
        value: "40.9",
        currency: "BUSD",
      },
      {
        id: 5,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "5/12/2021 13:30:23",
        value: "50.99",
        currency: "BUSD",
      },
    ],
    ownersData: [
      {
        id: 1,
        user: {
          name: "Pesho 1",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "20/06/22 24:33",
        value: "2.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "gosho 2",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "21/06/22 24:33",
        value: "15.6",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "Stef 3",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "22/06/22 24:33",
        value: "10.6",
        currency: "BUSD",
      },
    ],
    historyData: [
      {
        id: 1,
        event: "Mint",
        price: 1234567890123456789,
        currency: "ETH",
        from: "B323234965412365412541294311289541625131628541269",
        to: "Crypto-Kitties-Auction",
        date: "21/12/2020",
      },
      {
        id: 2,
        event: "Transfer",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "22/12/2020",
      },
      {
        id: 3,
        event: "List",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "31/12/2020",
      },
      {
        id: 3,
        event: "Sale",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction1876d46asdsa",
        date: "01/01/2021",
      },
      {
        id: 3,
        event: "Bid",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "15/01/2021",
      },
    ],
    more: [
      { id: 1 },
      { id: 3 },
      { id: 4 },
      { id: 5 },
      { id: 6 },
      { id: 7 },
      { id: 8 },
      { id: 9 },
    ],
  },
  {
    id: 2,
    imgSrc:
      "https://image.shutterstock.com/image-illustration/hero-sword-260nw-319561406.jpg",
    type: "pic",
    favorite: 12340,
    collectionName: "Sirvival Gear",
    collectionBadges: ["New", "Trending", "Verified"],
    currency: "Gems",
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
    creator: {
      name: "Gosho",
      avatar:
        "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
      royalties: 10,
    },
    details: {
      name: "Zombie CaptainAmerica #1",
      dropDate: "09 Oct 2021",
      listPrice: 90,
      editionSupply: 10,
      edition: 3,
      editionType: "Con Exclusive",
      season: "2",
      rarity: "Secret",
      license: "Marvel",
      brand: "Captain America",
      collection: "Zombie",
      series: "Zombie CaptainAmerica",
      annotations: ["rare", "wearable", "armor"],
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit commodi deleniti itaque adipisci sunt ducimus aperiam optio iste odit similique esse minima sed, tempore quo sapiente incidunt magnam alias nisi doloribus quae earum obcaecati ratione? Beatae, tempora voluptas adipisci in, suscipit praesentium explicabo odio quaerat, dolorem eaque tempore. Porro, saepe."
    },
    bids: [
      {
        id: 1,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "1/12/2021 13:38:55",
        value: "10.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "2/12/2021 13:37:00",
        value: "20",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "3/12/2021 13:35:00",
        value: "30.9",
        currency: "BUSD",
      },
      {
        id: 4,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "4/12/2021 13:33:23",
        value: "40.9",
        currency: "BUSD",
      },
      {
        id: 5,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "5/12/2021 13:30:23",
        value: "50.99",
        currency: "BUSD",
      },
    ],
    ownersData: [
      {
        id: 1,
        user: {
          name: "Pesho 1",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "20/06/22 24:33",
        value: "2.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "gosho 2",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "21/06/22 24:33",
        value: "15.6",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "Stef 3",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "22/06/22 24:33",
        value: "10.6",
        currency: "BUSD",
      },
    ],
    historyData: [
      {
        id: 1,
        event: "Mint",
        price: 1234567890123456789,
        currency: "ETH",
        from: "B323234965412365412541294311289541625131628541269",
        to: "Crypto-Kitties-Auction",
        date: "21/12/2020",
      },
      {
        id: 2,
        event: "Transfer",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "22/12/2020",
      },
      {
        id: 3,
        event: "List",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "31/12/2020",
      },
      {
        id: 3,
        event: "Sale",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction1876d46asdsa",
        date: "01/01/2021",
      },
      {
        id: 3,
        event: "Bid",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "15/01/2021",
      },
    ],
    more: [
      { id: 1 },
      { id: 3 },
      { id: 4 },
      { id: 5 },
      { id: 6 },
      { id: 7 },
      { id: 8 },
      { id: 9 },
    ],
  },
  {
    id: 3,
    imgSrc:
      "https://image.shutterstock.com/image-illustration/hero-sword-260nw-319561406.jpg",
    type: "pic",
    favorite: 12340,
    collectionName: "Sirvival Gear",
    collectionBadges: ["New", "Trending", "Verified"],
    currency: "Gems",
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
    creator: {
      name: "Gosho",
      avatar:
        "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
      royalties: 10,
    },
    details: {
      name: "Zombie CaptainAmerica #1",
      dropDate: "09 Oct 2021",
      listPrice: 90,
      editionSupply: 10,
      edition: 3,
      editionType: "Con Exclusive",
      season: "2",
      rarity: "Secret",
      license: "Marvel",
      brand: "Captain America",
      collection: "Zombie",
      series: "Zombie CaptainAmerica",
      annotations: ["rare", "wearable", "armor"],
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit commodi deleniti itaque adipisci sunt ducimus aperiam optio iste odit similique esse minima sed, tempore quo sapiente incidunt magnam alias nisi doloribus quae earum obcaecati ratione? Beatae, tempora voluptas adipisci in, suscipit praesentium explicabo odio quaerat, dolorem eaque tempore. Porro, saepe."
    },
    bids: [
      {
        id: 1,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "1/12/2021 13:38:55",
        value: "10.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "2/12/2021 13:37:00",
        value: "20",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "3/12/2021 13:35:00",
        value: "30.9",
        currency: "BUSD",
      },
      {
        id: 4,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "4/12/2021 13:33:23",
        value: "40.9",
        currency: "BUSD",
      },
      {
        id: 5,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "5/12/2021 13:30:23",
        value: "50.99",
        currency: "BUSD",
      },
    ],
    ownersData: [
      {
        id: 1,
        user: {
          name: "Pesho 1",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "20/06/22 24:33",
        value: "2.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "gosho 2",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "21/06/22 24:33",
        value: "15.6",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "Stef 3",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "22/06/22 24:33",
        value: "10.6",
        currency: "BUSD",
      },
    ],
    historyData: [
      {
        id: 1,
        event: "Mint",
        price: 1234567890123456789,
        currency: "ETH",
        from: "B323234965412365412541294311289541625131628541269",
        to: "Crypto-Kitties-Auction",
        date: "21/12/2020",
      },
      {
        id: 2,
        event: "Transfer",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "22/12/2020",
      },
      {
        id: 3,
        event: "List",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "31/12/2020",
      },
      {
        id: 3,
        event: "Sale",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction1876d46asdsa",
        date: "01/01/2021",
      },
      {
        id: 3,
        event: "Bid",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "15/01/2021",
      },
    ],
    more: [
      { id: 1 },
      { id: 3 },
      { id: 4 },
      { id: 5 },
      { id: 6 },
      { id: 7 },
      { id: 8 },
      { id: 9 },
    ],
  },
  {
    id: 4,
    imgSrc:
      "https://static.turbosquid.com/Preview/2019/11/16__17_52_47/CoverImage.jpg9988E0CD-074F-4988-BD5A-8A75FB46C8F3Large.jpg",
    type: "pic",
    favorite: 1234567,
    collectionName: "Knights of honor",
    collectionBadges: ["Verified"],
    currency: "Gems",
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
    creator: {
      name: "Gosho",
      avatar:
        "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
      royalties: 10,
    },
    details: {
      name: "Zombie CaptainAmerica #1",
      dropDate: "09 Oct 2021",
      listPrice: 90,
      editionSupply: 10,
      edition: 3,
      editionType: "Con Exclusive",
      season: "2",
      rarity: "Secret",
      license: "Marvel",
      brand: "Captain America",
      collection: "Zombie",
      series: "Zombie CaptainAmerica",
      annotations: ["rare", "wearable", "armor"],
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit commodi deleniti itaque adipisci sunt ducimus aperiam optio iste odit similique esse minima sed, tempore quo sapiente incidunt magnam alias nisi doloribus quae earum obcaecati ratione? Beatae, tempora voluptas adipisci in, suscipit praesentium explicabo odio quaerat, dolorem eaque tempore. Porro, saepe."
    },
    bids: [
      {
        id: 1,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "1/12/2021 13:38:55",
        value: "10.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "2/12/2021 13:37:00",
        value: "20",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "3/12/2021 13:35:00",
        value: "30.9",
        currency: "BUSD",
      },
      {
        id: 4,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "4/12/2021 13:33:23",
        value: "40.9",
        currency: "BUSD",
      },
      {
        id: 5,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "5/12/2021 13:30:23",
        value: "50.99",
        currency: "BUSD",
      },
    ],
    ownersData: [
      {
        id: 1,
        user: {
          name: "Pesho 1",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "20/06/22 24:33",
        value: "2.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "gosho 2",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "21/06/22 24:33",
        value: "15.6",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "Stef 3",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "22/06/22 24:33",
        value: "10.6",
        currency: "BUSD",
      },
    ],
    historyData: [
      {
        id: 1,
        event: "Mint",
        price: 1234567890123456789,
        currency: "ETH",
        from: "B323234965412365412541294311289541625131628541269",
        to: "Crypto-Kitties-Auction",
        date: "21/12/2020",
      },
      {
        id: 2,
        event: "Transfer",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "22/12/2020",
      },
      {
        id: 3,
        event: "List",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "31/12/2020",
      },
      {
        id: 3,
        event: "Sale",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction1876d46asdsa",
        date: "01/01/2021",
      },
      {
        id: 3,
        event: "Bid",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "15/01/2021",
      },
    ],
    more: [
      { id: 1 },
      { id: 3 },
      { id: 4 },
      { id: 5 },
      { id: 6 },
      { id: 7 },
      { id: 8 },
      { id: 9 },
    ],
  },
  {
    id: 5,
    imgSrc:
      "https://static.turbosquid.com/Preview/2014/05/27__05_24_00/helmhigh_+(5).jpgf7930edd-066d-4545-83cc-edf1b4aec9c0Larger.jpg",
    type: "pic",
    favorite: 12345678,
    collectionName: "Knights of honor",
    collectionBadges: ["Verified"],
    currency: "Gems",
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
    creator: {
      name: "Gosho",
      avatar:
        "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
      royalties: 10,
    },
    details: {
      name: "Zombie CaptainAmerica #1",
      dropDate: "09 Oct 2021",
      listPrice: 90,
      editionSupply: 10,
      edition: 3,
      editionType: "Con Exclusive",
      season: "2",
      rarity: "Secret",
      license: "Marvel",
      brand: "Captain America",
      collection: "Zombie",
      series: "Zombie CaptainAmerica",
      annotations: ["rare", "wearable", "armor"],
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit commodi deleniti itaque adipisci sunt ducimus aperiam optio iste odit similique esse minima sed, tempore quo sapiente incidunt magnam alias nisi doloribus quae earum obcaecati ratione? Beatae, tempora voluptas adipisci in, suscipit praesentium explicabo odio quaerat, dolorem eaque tempore. Porro, saepe."
    },
    bids: [
      {
        id: 1,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "1/12/2021 13:38:55",
        value: "10.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "2/12/2021 13:37:00",
        value: "20",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "3/12/2021 13:35:00",
        value: "30.9",
        currency: "BUSD",
      },
      {
        id: 4,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "4/12/2021 13:33:23",
        value: "40.9",
        currency: "BUSD",
      },
      {
        id: 5,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "5/12/2021 13:30:23",
        value: "50.99",
        currency: "BUSD",
      },
    ],
    ownersData: [
      {
        id: 1,
        user: {
          name: "Pesho 1",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "20/06/22 24:33",
        value: "2.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "gosho 2",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "21/06/22 24:33",
        value: "15.6",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "Stef 3",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "22/06/22 24:33",
        value: "10.6",
        currency: "BUSD",
      },
    ],
    historyData: [
      {
        id: 1,
        event: "Mint",
        price: 1234567890123456789,
        currency: "ETH",
        from: "B323234965412365412541294311289541625131628541269",
        to: "Crypto-Kitties-Auction",
        date: "21/12/2020",
      },
      {
        id: 2,
        event: "Transfer",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "22/12/2020",
      },
      {
        id: 3,
        event: "List",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "31/12/2020",
      },
      {
        id: 3,
        event: "Sale",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction1876d46asdsa",
        date: "01/01/2021",
      },
      {
        id: 3,
        event: "Bid",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "15/01/2021",
      },
    ],
    more: [
      { id: 1 },
      { id: 3 },
      { id: 4 },
      { id: 5 },
      { id: 6 },
      { id: 7 },
      { id: 8 },
      { id: 9 },
    ],
  },
  {
    id: 6,
    imgSrc:
      "https://netrinoimages.s3.eu-west-2.amazonaws.com/2021/02/10/803869/335810/armor_3d_model_c4d_max_obj_fbx_ma_lwo_3ds_3dm_stl_3520110_o.png",
    type: "pic",
    favorite: 123456789,
    collectionName: "Knights of honor",
    collectionBadges: ["Verified"],
    currency: "Gems",
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
    creator: {
      name: "Gosho",
      avatar:
        "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
      royalties: 10,
    },
    details: {
      name: "Zombie CaptainAmerica #1",
      dropDate: "09 Oct 2021",
      listPrice: 90,
      editionSupply: 10,
      edition: 3,
      editionType: "Con Exclusive",
      season: "2",
      rarity: "Secret",
      license: "Marvel",
      brand: "Captain America",
      collection: "Zombie",
      series: "Zombie CaptainAmerica",
      annotations: ["rare", "wearable", "armor"],
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit commodi deleniti itaque adipisci sunt ducimus aperiam optio iste odit similique esse minima sed, tempore quo sapiente incidunt magnam alias nisi doloribus quae earum obcaecati ratione? Beatae, tempora voluptas adipisci in, suscipit praesentium explicabo odio quaerat, dolorem eaque tempore. Porro, saepe."
    },
    bids: [
      {
        id: 1,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "1/12/2021 13:38:55",
        value: "10.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "2/12/2021 13:37:00",
        value: "20",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "3/12/2021 13:35:00",
        value: "30.9",
        currency: "BUSD",
      },
      {
        id: 4,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "4/12/2021 13:33:23",
        value: "40.9",
        currency: "BUSD",
      },
      {
        id: 5,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "5/12/2021 13:30:23",
        value: "50.99",
        currency: "BUSD",
      },
    ],
    ownersData: [
      {
        id: 1,
        user: {
          name: "Pesho 1",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "20/06/22 24:33",
        value: "2.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "gosho 2",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "21/06/22 24:33",
        value: "15.6",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "Stef 3",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "22/06/22 24:33",
        value: "10.6",
        currency: "BUSD",
      },
    ],
    historyData: [
      {
        id: 1,
        event: "Mint",
        price: 1234567890123456789,
        currency: "ETH",
        from: "B323234965412365412541294311289541625131628541269",
        to: "Crypto-Kitties-Auction",
        date: "21/12/2020",
      },
      {
        id: 2,
        event: "Transfer",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "22/12/2020",
      },
      {
        id: 3,
        event: "List",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "31/12/2020",
      },
      {
        id: 3,
        event: "Sale",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction1876d46asdsa",
        date: "01/01/2021",
      },
      {
        id: 3,
        event: "Bid",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "15/01/2021",
      },
    ],
    more: [
      { id: 1 },
      { id: 3 },
      { id: 4 },
      { id: 5 },
      { id: 6 },
      { id: 7 },
      { id: 8 },
      { id: 9 },
    ],
  },
  {
    id: 7,
    imgSrc:
      "https://image.shutterstock.com/image-illustration/roman-armor-3d-illustration-isolated-260nw-1304966134.jpg",
    type: "pic",
    favorite: 330,
    collectionName: "Titan",
    collectionBadges: ["Verified"],
    currency: "Gems",
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
    creator: {
      name: "Gosho",
      avatar:
        "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
      royalties: 10,
    },
    details: {
      name: "Zombie CaptainAmerica #1",
      dropDate: "09 Oct 2021",
      listPrice: 90,
      editionSupply: 10,
      edition: 3,
      editionType: "Con Exclusive",
      season: "2",
      rarity: "Secret",
      license: "Marvel",
      brand: "Captain America",
      collection: "Zombie",
      series: "Zombie CaptainAmerica",
      annotations: ["rare", "wearable", "armor"],
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit commodi deleniti itaque adipisci sunt ducimus aperiam optio iste odit similique esse minima sed, tempore quo sapiente incidunt magnam alias nisi doloribus quae earum obcaecati ratione? Beatae, tempora voluptas adipisci in, suscipit praesentium explicabo odio quaerat, dolorem eaque tempore. Porro, saepe."
    },
    bids: [
      {
        id: 1,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "1/12/2021 13:38:55",
        value: "10.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "2/12/2021 13:37:00",
        value: "20",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "3/12/2021 13:35:00",
        value: "30.9",
        currency: "BUSD",
      },
      {
        id: 4,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "4/12/2021 13:33:23",
        value: "40.9",
        currency: "BUSD",
      },
      {
        id: 5,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "5/12/2021 13:30:23",
        value: "50.99",
        currency: "BUSD",
      },
    ],
    ownersData: [
      {
        id: 1,
        user: {
          name: "Pesho 1",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "20/06/22 24:33",
        value: "2.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "gosho 2",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "21/06/22 24:33",
        value: "15.6",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "Stef 3",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "22/06/22 24:33",
        value: "10.6",
        currency: "BUSD",
      },
    ],
    historyData: [
      {
        id: 1,
        event: "Mint",
        price: 1234567890123456789,
        currency: "ETH",
        from: "B323234965412365412541294311289541625131628541269",
        to: "Crypto-Kitties-Auction",
        date: "21/12/2020",
      },
      {
        id: 2,
        event: "Transfer",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "22/12/2020",
      },
      {
        id: 3,
        event: "List",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "31/12/2020",
      },
      {
        id: 3,
        event: "Sale",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction1876d46asdsa",
        date: "01/01/2021",
      },
      {
        id: 3,
        event: "Bid",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "15/01/2021",
      },
    ],
    more: [
      { id: 1 },
      { id: 3 },
      { id: 4 },
      { id: 5 },
      { id: 6 },
      { id: 7 },
      { id: 8 },
      { id: 9 },
    ],
  },
  {
    id: 8,
    imgSrc:
      "https://lh3.googleusercontent.com/9V3uY2fM9IwRzFPv8mvle13s-P0XmTMuc2rRIUWhAZ5djENWmcQuuyYqjnCc9jcg8Wscn9CDkJGT2n26knnM8Gv4Gw=w600",
    type: "pic",
    favorite: 330,
    collectionName: "Knights of honor",
    collectionBadges: ["Verified"],
    currency: "Gems",
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
    creator: {
      name: "Gosho",
      avatar:
        "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
      royalties: 10,
    },
    details: {
      name: "Zombie CaptainAmerica #1",
      dropDate: "09 Oct 2021",
      listPrice: 90,
      editionSupply: 10,
      edition: 3,
      editionType: "Con Exclusive",
      season: "2",
      rarity: "Secret",
      license: "Marvel",
      brand: "Captain America",
      collection: "Zombie",
      series: "Zombie CaptainAmerica",
      annotations: ["rare", "wearable", "armor"],
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit commodi deleniti itaque adipisci sunt ducimus aperiam optio iste odit similique esse minima sed, tempore quo sapiente incidunt magnam alias nisi doloribus quae earum obcaecati ratione? Beatae, tempora voluptas adipisci in, suscipit praesentium explicabo odio quaerat, dolorem eaque tempore. Porro, saepe."
    },
    bids: [
      {
        id: 1,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "1/12/2021 13:38:55",
        value: "10.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "2/12/2021 13:37:00",
        value: "20",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "3/12/2021 13:35:00",
        value: "30.9",
        currency: "BUSD",
      },
      {
        id: 4,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "4/12/2021 13:33:23",
        value: "40.9",
        currency: "BUSD",
      },
      {
        id: 5,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "5/12/2021 13:30:23",
        value: "50.99",
        currency: "BUSD",
      },
    ],
    ownersData: [
      {
        id: 1,
        user: {
          name: "Pesho 1",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "20/06/22 24:33",
        value: "2.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "gosho 2",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "21/06/22 24:33",
        value: "15.6",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "Stef 3",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "22/06/22 24:33",
        value: "10.6",
        currency: "BUSD",
      },
    ],
    historyData: [
      {
        id: 1,
        event: "Mint",
        price: 1234567890123456789,
        currency: "ETH",
        from: "B323234965412365412541294311289541625131628541269",
        to: "Crypto-Kitties-Auction",
        date: "21/12/2020",
      },
      {
        id: 2,
        event: "Transfer",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "22/12/2020",
      },
      {
        id: 3,
        event: "List",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "31/12/2020",
      },
      {
        id: 3,
        event: "Sale",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction1876d46asdsa",
        date: "01/01/2021",
      },
      {
        id: 3,
        event: "Bid",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "15/01/2021",
      },
    ],
    more: [
      { id: 1 },
      { id: 3 },
      { id: 4 },
      { id: 5 },
      { id: 6 },
      { id: 7 },
      { id: 8 },
      { id: 9 },
    ],
  },
  {
    id: 9,
    imgSrc:
      "https://media.sketchfab.com/models/86fd6cec31e347289571a039852c02ed/thumbnails/d5826ebcceac4a36a2e2c1382506ab39/5da9b4d3987f4c7396a4ffe179a149bf.jpeg",
    type: "pic",
    favorite: 13,
    collectionName: "Eternal Glory",
    collectionBadges: ["Verified"],
    currency: "Gems",
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
    creator: {
      name: "Gosho",
      avatar:
        "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
      royalties: 10,
    },
    details: {
      name: "Zombie CaptainAmerica #1",
      dropDate: "09 Oct 2021",
      listPrice: 90,
      editionSupply: 10,
      edition: 3,
      editionType: "Con Exclusive",
      season: "2",
      rarity: "Secret",
      license: "Marvel",
      brand: "Captain America",
      collection: "Zombie",
      series: "Zombie CaptainAmerica",
      annotations: ["rare", "wearable", "armor"],
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit commodi deleniti itaque adipisci sunt ducimus aperiam optio iste odit similique esse minima sed, tempore quo sapiente incidunt magnam alias nisi doloribus quae earum obcaecati ratione? Beatae, tempora voluptas adipisci in, suscipit praesentium explicabo odio quaerat, dolorem eaque tempore. Porro, saepe."
    },
    bids: [
      {
        id: 1,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "1/12/2021 13:38:55",
        value: "10.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "2/12/2021 13:37:00",
        value: "20",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "3/12/2021 13:35:00",
        value: "30.9",
        currency: "BUSD",
      },
      {
        id: 4,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "4/12/2021 13:33:23",
        value: "40.9",
        currency: "BUSD",
      },
      {
        id: 5,
        user: {
          name: "HyperStudio",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        type: "bid",
        time: "5/12/2021 13:30:23",
        value: "50.99",
        currency: "BUSD",
      },
    ],
    ownersData: [
      {
        id: 1,
        user: {
          name: "Pesho 1",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "20/06/22 24:33",
        value: "2.6",
        currency: "BUSD",
      },
      {
        id: 2,
        user: {
          name: "gosho 2",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "21/06/22 24:33",
        value: "15.6",
        currency: "BUSD",
      },
      {
        id: 3,
        user: {
          name: "Stef 3",
          avatar:
            "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xee63d9ca6ecaa334ba0c3311b3dbd5de0132ba4c/avatar/QmZQcqw38q6z7yKGXZx86o6Mn2mnUPF4CoscnMbCTXqboQ",
        },
        dateOfOwnership: "22/06/22 24:33",
        value: "10.6",
        currency: "BUSD",
      },
    ],
    historyData: [
      {
        id: 1,
        event: "Mint",
        price: 1234567890123456789,
        currency: "ETH",
        from: "B323234965412365412541294311289541625131628541269",
        to: "Crypto-Kitties-Auction",
        date: "21/12/2020",
      },
      {
        id: 2,
        event: "Transfer",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "22/12/2020",
      },
      {
        id: 3,
        event: "List",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "31/12/2020",
      },
      {
        id: 3,
        event: "Sale",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction1876d46asdsa",
        date: "01/01/2021",
      },
      {
        id: 3,
        event: "Bid",
        price: 12,
        currency: "ETH",
        from: "B32323",
        to: "Crypto-Kitties-Auction",
        date: "15/01/2021",
      },
    ],
    more: [
      { id: 1 },
      { id: 3 },
      { id: 4 },
      { id: 5 },
      { id: 6 },
      { id: 7 },
      { id: 8 },
      { id: 9 },
    ],
  },
];

export const groupedOptions = [
  {
    label: "Colours",
    options: trendingData,
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
  },
  {
    label: "Flavours",
    options: [
      {
        id: 0,
        imgSrc:
          "https://media.sketchfab.com/models/86fd6cec31e347289571a039852c02ed/thumbnails/d5826ebcceac4a36a2e2c1382506ab39/5da9b4d3987f4c7396a4ffe179a149bf.jpeg",
        type: "pic",
        favorite: 13,
        collectionName: "Eternal Glory",
        collectionBadges: ["Verified"],
        itemName: "Gloves of Worship",
        priceValue: "5",
        priceCurrency: "ETH",
        bidValue: "4",
        collectionSupply: "10",
        collectionIndex: "3",
        annotationBadges: ["rare", "wearable", "armor"],
        listing: {
          completed: true,
          hasStarted: false,
          countdownEnd: "Dec 30, 2021 23:45:00",
        },
      },
    ],
    listing: {
      completed: true,
      hasStarted: false,
      countdownEnd: "Dec 30, 2021 23:45:00",
    },
  },
];

export default trendingData;
